import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Event } from "event-system";
import { Container, Geometry, IDestroyOptions, Mesh, Shader, Ticker } from "pixi.js";
import Fragment from "../components/shader/glowrotation/glowrotation.frag";
import Vertex from "../components/shader/glowrotation/glowrotation.vert";

export class LandlordGlowRotationAnimation extends Container {
    public readonly onAnimationProgressChange: Event<number>;
    private readonly mesh: Mesh<Shader>;
    private flag: boolean;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.onAnimationProgressChange = new Event<number>();
        const geometry = new Geometry();
        geometry.addAttribute("aVertexPosition", [0, 0, 1, 0, 1, 1, 0, 1], 2);
        geometry.addAttribute("aUvs", [0, 0, 1, 0, 1, 1, 0, 1], 2);
        geometry.addIndex([0, 1, 2, 0, 2, 3]);
        const uniforms = {
            u_canvas_ratio: canvasScaler.referenceRatio,
            u_mask_progress: 0,
            u_time: 0,
            u_scale: 2.25,
            u_pos_x: 0.5,
            u_pos_y: 0.5,
        };
        const shader = Shader.from(Vertex, Fragment, uniforms);
        this.mesh = new Mesh(geometry, shader);
        this.mesh.scale.set(canvasScaler.referenceWidth, canvasScaler.referenceHeight * canvasScaler.referenceRatio * 0.45);
        this.mesh.position.set(-canvasScaler.referenceWidth * 0.5, 0);
        this.addChild(this.mesh);
        this.mesh.shader.uniforms.u_mask_progress = 2;
        Ticker.shared.add(this.update, this);
    }

    private update(dt: number): void {
        this.mesh.shader.uniforms.u_time += dt;
        if (this.mesh.shader.uniforms.u_mask_progress < 2 && !this.flag) {
            this.mesh.shader.uniforms.u_mask_progress += 0.02;
        }
    }

    public async play(): Promise<void> {
        this.reset();
    }

    private reset(): void {
        this.mesh.shader.uniforms.u_time = 0;
        this.mesh.shader.uniforms.u_mask_progress = 0;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        Ticker.shared.remove(this.update, this);
        super.destroy(options);
    }
}
